







































































// vendor
import { defineComponent, computed, inject, ComputedRef } from "@vue/composition-api";
// import { format as formatDate } from "date-fns";
// project
import { PreviewAssetGraph } from "@/components.assets/preview-asset-graph";
import { StudyContext } from "@/components.studies/manage-study";
import { Date as DisplayDate } from "@ui";
import { useTranslate } from "@lang";

export default defineComponent({
	components:{
		PreviewAssetGraph,
		DisplayDate,
	},
	setup(){


		const {
			translate
		} = useTranslate();

		const studyContext = inject<ComputedRef<StudyContext>>("studyContext");

		if(!studyContext){ throw Error("Blueprint Preview: Study context missing!"); }

		const {
			blueprint,
			blueprintVersion,
		} = studyContext.value;


		const blueprintId = computed(() => {
			return blueprint.value ? blueprint.value._id : "";
		});
		
		const versionId = computed(() => {
			return blueprintVersion.value ? blueprintVersion.value._id : "";
		});

		const blueprintLabel = computed(() => {
			return blueprint.value ? blueprint.value.name : "";
		});

		const versionLabel = computed(() => {
			if(!blueprintVersion.value){ return ""; }
			const name = blueprintVersion.value.name;
			const vindex = blueprintVersion.value.vIndex;
			if(name){
				return `${name} (v${vindex})`
			}
			return `${translate("assets.label.version")} ${vindex + 1}`;
			// return blueprintVersion.value ? blueprintVersion.value.vIndex : "";
		});

		// const dateLabel = computed(() => {
		// 	if(!blueprintVersion.value){ return ""; }
		// 	return formatDate(new Date(blueprintVersion.value.created), "EEEE MMM. MM, y");
		// });

		return {
			blueprint,
			blueprintVersion,
			blueprintLabel,
			versionLabel,
			// dateLabel,
			blueprintId,
			versionId,
		};
	}
});

